import { Image, Flex, Text, BoxProps, HStack } from '@chakra-ui/react';
import { i_text_copy_bold } from '../../style';
import Card from '../../iZUMi-UI-toolkit/src/components/Card/Card';
import { getColorThemeSelector } from '../../utils/funcs';
import { useColorMode } from '@chakra-ui/color-mode';
import { TokenInfoFormatted } from '../../hooks/useTokenListFormatted';
import useIsMobile from '../../hooks/useIsMobile';

type DirectionProps = {
    entry: {
        tokenX: TokenInfoFormatted;
        tokenY: TokenInfoFormatted;
        isSellTokenX: boolean;
    };
    variant?: string;
} & BoxProps;

export const Direction: React.FC<DirectionProps> = ({ entry, ...rest }) => {
    const { tokenX, tokenY, isSellTokenX } = entry;
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);
    const isMobile = useIsMobile();
    return isMobile ? (
        <Card key="CoinIcons" w="100%" h="36px" flexShrink={0} variant="light" {...rest}>
            <HStack h="100%" justifyContent="center" spacing="20px">
                <Flex direction="row" alignItems="center">
                    <Image borderRadius="15px" h="15px" w="15px" flexShrink={0} src={(isSellTokenX ? tokenX : tokenY)?.icon} />
                    <Text className={i_text_copy_bold} ml="6px">
                        {isSellTokenX ? tokenX.symbol : tokenY.symbol}
                    </Text>
                </Flex>

                <Image w="18px" src={process.env.PUBLIC_URL + colorTheme('/assets/trade/lightArrow.svg', '/assets/trade/darkArrow.svg')} />

                <Flex direction="row" alignItems="center">
                    <Image borderRadius="15px" h="15px" w="15px" flexShrink={0} src={(isSellTokenX ? tokenY : tokenX)?.icon} />
                    <Text className={i_text_copy_bold} ml="6px">
                        {isSellTokenX ? tokenY.symbol : tokenX.symbol}
                    </Text>
                </Flex>
            </HStack>
        </Card>
    ) : (
        <Card key="CoinIcons" w="180px" h="36px" flexShrink={0} variant="light" {...rest}>
            <HStack h="100%" justifyContent="center" spacing="12px">
                <Flex direction="row" alignItems="center">
                    <Image borderRadius="15px" h="15px" w="15px" flexShrink={0} src={(isSellTokenX ? tokenX : tokenY)?.icon} />
                    <Text className={i_text_copy_bold} ml="6px">
                        {isSellTokenX ? tokenX.symbol : tokenY.symbol}
                    </Text>
                </Flex>

                <Image w="18px" src={process.env.PUBLIC_URL + colorTheme('/assets/trade/lightArrow.svg', '/assets/trade/darkArrow.svg')} />

                <Flex direction="row" alignItems="center">
                    <Image borderRadius="15px" h="15px" w="15px" flexShrink={0} src={(isSellTokenX ? tokenY : tokenX)?.icon} />
                    <Text className={i_text_copy_bold} ml="6px">
                        {isSellTokenX ? tokenY.symbol : tokenX.symbol}
                    </Text>
                </Flex>
            </HStack>
        </Card>
    );
};
